import React from "react";

export default function UnsupportedMedia() {
  return (
    <div className="font-italic">
      Content format is not supported on web. Please check from mobile apps.
    </div>
  );
}
